import { Separator, Text } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { navigateLanguagesAndCopyContentDocsUrl } from "../../app/constants/documentationLinks"
import { SettingsPage } from "../SettingsPage"
import { SettingsPageBodyHeader } from "../SettingsPageBodyHeader"
import { SettingsPageBodySection } from "../SettingsPageBodySection"
import { LocalesTable, LocalesTableSkeleton } from "./LocalesTable"

export function LocalesPage() {
  return (
    <SettingsPage pageName="Locales">
      <SettingsPageBodyHeader
        title="Translations & Locales"
        description={
          <>
            Learn how to{" "}
            <Text
              color="grey11"
              href={navigateLanguagesAndCopyContentDocsUrl}
              inline
              underline
            >
              translate and localize content in Prismic
            </Text>
            .
          </>
        }
      />

      <Separator style="dashed" />

      <SettingsPageBodySection
        title="Add new locales to this repository"
        description="Select an existing locale from the list, or create your own."
      />

      <Separator style="dashed" />

      <SettingsPageBodySection
        title="Manage your locales"
        description="The master locale is the default locale of your repository."
      >
        <Suspense fallback={<LocalesTableSkeleton />}>
          <LocalesTable />
        </Suspense>
      </SettingsPageBodySection>
    </SettingsPage>
  )
}
